import { createSlice } from '@reduxjs/toolkit';

// Shape: { [pageKey]: { values: {...}, autoTriggered: {...} } }
const initialState = {};

const getOrCreatePage = (state, pageKey) => {
  if (!state[pageKey]) {
    state[pageKey] = { values: {}, autoTriggered: {} };
  }
  return state[pageKey];
};

const filters = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    // Set a single filter value for a page (e.g. globalFilterValue)
    setPageFilterValue: (state, action) => {
      const { pageKey, key, value } = action.payload;
      const page = getOrCreatePage(state, pageKey);
      page.values[key] = value;
    },
    // Merge multiple filter values at once for a page
    setPageFilterValues: (state, action) => {
      const { pageKey, values } = action.payload;
      const page = getOrCreatePage(state, pageKey);
      page.values = { ...page.values, ...values };
    },
    // Records "the value we already auto-triggered a search/filter for",
    // keyed by filter name, so effects can diff against it and avoid
    // re-triggering (and thus avoid infinite loops) once a value repeats.
    setAutoTriggeredValue: (state, action) => {
      const { pageKey, key, value } = action.payload;
      const page = getOrCreatePage(state, pageKey);
      page.autoTriggered[key] = value;
    },
    resetPageFilters: (state, action) => {
      const { pageKey } = action.payload;
      delete state[pageKey];
    },
    resetAllFilters: () => initialState
  }
});

export const {
  setPageFilterValue,
  setPageFilterValues,
  setAutoTriggeredValue,
  resetPageFilters,
  resetAllFilters
} = filters.actions;

export default filters.reducer;